import { MediaV2Api } from '@calm/evexia-web-sdk/generated/lib/api/media-v2-api';
import { AxiosInstance } from 'axios';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `MediaV2Api`
 * @param accessToken
 * @returns
 */
export default function createMediaV2Api(
    accessToken: () => Promise<string>,
    client?: AxiosInstance
) {
    return createApi(MediaV2Api, accessToken, undefined, client);
}
